import autoBind from 'react-autobind/src/autoBind';
import React, { Component } from 'react';
import ConfirmDialogUpdateTosForm from 'src/components/company/confirm-dialog-update-tos-form';
import { connect } from 'react-redux';
import { Entities, patch } from 'src/common';

class ConfirmDialogUpdateTos extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
    }

    callSubmit() {
        return this.childForm.submit();
    }

    didFormChange() {
        return !this.childForm.pristine;
    }

    render() {
        const { t, busCompany } = this.props;
        const initialValues = {
            confirmTos: false,
            confirmLiability: false,
            confirmCostSheet: false,
        };

        return (
            <>
                <ConfirmDialogUpdateTosForm
                    t={t}
                    busCompany={busCompany}
                    initialValues={initialValues}
                    onSubmit={this.handleSubmit}
                    ref={ref => (this.childForm = ref)}
                    handleClose={this.props.handleClose}
                />
            </>
        );
    }

    handleSubmit(data) {
        const { busCompany, status, patch } = this.props;
        if (status !== 'not_visible') return;
        patch({ id: busCompany.id }, Entities.BUS_COMPANY, 0, undefined, undefined, 'requestVisibilityTosUpdate');
        this.props.handleClose();
    }
}

const mapStateToProps = state => {
    return {};
};

export default connect(mapStateToProps, { patch }, null, { withRef: true })(ConfirmDialogUpdateTos);
